import { Accordion, AccordionDetails, AccordionSummary, styled } from "@mui/material";

import { Box } from "@/Components/v2/atoms/Box";

export const StyledTableHeaderRow = styled(Box)(({ theme }) => ({
  display: "flex",
  backgroundColor: theme.palette.tableColumnHeader.background,
  borderBottom: "1px solid rgba(224, 224, 224, 1)",
  minHeight: "36px",
  alignItems: "center",
  padding: "8px 12px",
}));

export const StyledTableRow = styled(Box)(() => ({
  display: "flex",
  borderBottom: "1px solid rgba(224, 224, 224, 1)",
  minHeight: "48px",
  alignItems: "center",
  padding: "6px 12px",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.02)",
  },
  "&:last-child": {
    borderBottom: "none",
  },
}));

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "6px",
  marginBottom: theme.spacing(1.5),
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
  overflow: "hidden",

  "&:before": {
    display: "none",
  },
}));

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  backgroundColor: theme.palette.businessUnitHierarchyHeader.background,
  color: theme.palette.businessUnitHierarchyHeader.textColor,
  minHeight: "44px",
  margin: 0,
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: theme.palette.businessUnitHierarchyHeader.textColor,
  },
  "& .MuiAccordionSummary-content": {
    margin: "12px 0",
  },
}));

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  "&.MuiAccordionDetails-root": {
    padding: 0,
  },
  borderTop: `1px solid ${theme.palette.divider}`,
  overflow: "hidden",
}));
